import { TimelineItemState } from 'components/generics/Timeline/index';

export const getStateTimelineItem = (currentStep: number, index: number) => {
  if (index < currentStep) {
    return TimelineItemState.PASSED;
  } else if (index === currentStep) {
    return TimelineItemState.CURRENT;
  } else {
    return TimelineItemState.NEXT;
  }
};
